import { createFileRoute } from '@tanstack/react-router';
import ChainPublicPage from '../views/chain-public';

// Public chain scorecard view. Accepts either the human-readable slug
// (preferred — what gets shared in emails / links) or the UUID. Backend
// resolves both at /chains/public/{uuid_or_slug}. No auth required.
export const Route = createFileRoute('/chain/$slugOrUuid')({
  component: ChainPublicPage,
});
